<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">外考报名</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem text-center">
                        <el-button @click="WKStu" type="success" style="margin-left: 10px"><i
                                class="el-icon-document-copy"></i>&nbsp;报名信息</el-button>
                        <el-button @click="personInfoDialogVisible = true" type="warning" style="margin-left: 10px"><i
                                class="el-icon-user"></i>&nbsp;个人信息</el-button>
                                <el-button @click="supplementInfoDialogVisible = true" type="primary" style="margin-left: 10px"><i
                                        class="el-icon-user"></i>&nbsp;信息补全</el-button>
                    </div>
                </div>
            </div>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有科目信息</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">外考考试名称：</label>{{ item.wkksmc }}</p>
                        <p><label for="">报名开始时间：</label>{{ item.bmkssj }}</p>
                        <p><label for="">报名结束时间：</label>{{ item.bmjssj }}</p>
                        <p><label for="">考试日期：</label>{{ item.kssj }}</p>
                        <p><label for="">报名费用：</label>{{ item.ksfy }}</p>
                        <p><label for="">报名人数：</label>{{ item.bmrs }}</p>
                        <p><label for="">备注：</label>{{ item.bz }}</p>
                        <div class="auditStateImg">
                            <img v-if="item.sfbm=='1'" :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button v-if="item.sfbm!=='1'" type="primary" @click="checkBM(item)">报名
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="personInfoDialog" class="formDialog" title="个人报名信息" :visible.sync="WKStuDialogVisible"
                width="90%" top="-20px" @open="queryWKStu">
                <div id="mobileMode_person">
                    <div id="listArea_person">

                        <div v-if="WKStuTableData==null || WKStuTableData.length==0" class="cardTips">没有报名记录</div>

                        <div class="cardMain" v-for="(item,index) in WKStuTableData" :key="index">
                            <div class="cardText">
                                <p><label for="">外考考试名称：</label>{{ item.wkksmc }}</p>
                                <p><label for="">考试日期：</label>{{ item.kssj }}</p>
                            </div>
                            <div class="cardInput">
                                <el-button size="small" v-if="item.sfjf == 0" @click="delWKSelection(item);"
                                    type="danger">
                                    删除
                                </el-button>
                            </div>
                        </div>

                    </div>
                </div>

            </el-dialog>

            <el-dialog id="personInfoDialog" class="formDialog" :visible.sync="personInfoDialogVisible" width="90%" @open="openSupplementInfoDialog">
                <template slot="title">
                    <span style="font-size: 18px;color: #303133;font-weight: bold;">个人信息</span>
                </template>

                <div id="mobileMode_person">
                    <div id="listArea_person">
                        <!-- <div style="text-align:center;">
                            <el-button @click="supplementInfoDialogVisible = true" type="primary">
                                <i class="el-icon-edit"></i>&nbsp;个人信息补全
                            </el-button>
                        </div> -->

                        <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                            <el-form label-width="84px" label-position="left" width="100%">

                                <div style="text-align: center;">
                                    <img v-if="imageUrl" :src="imageUrl"  style="width: 100px;"/>
                                </div>

                                <el-form-item label="姓名">
                                    {{personInfoData.xm}}
                                </el-form-item>

                                <el-form-item label="学号">
                                    {{personInfoData.xh}}
                                </el-form-item>

                                <el-form-item label="性别">
                                    {{personInfoData.xb}}
                                </el-form-item>

                                <el-form-item label="班级">
                                    {{personInfoData.bj}}
                                </el-form-item>

                                <el-form-item label="出生年月">
                                    {{personInfoData.csny}}
                                </el-form-item>

                                <el-form-item label="身份证号">
                                    {{personInfoData.sfzh}}
                                </el-form-item>

                                <el-form-item label="政治面貌">
                                    {{personInfoData.zzmm}}
                                </el-form-item>

                                <el-form-item label="民族">
                                    {{personInfoData.mz}}
                                </el-form-item>

                                <el-form-item label="联系电话">
                                    {{personInfoData.lxdh}}
                                </el-form-item>

                                <el-form-item label="电子邮箱">
                                    {{personInfoData.dzyx}}
                                </el-form-item>

                                <el-form-item label="家庭住址">
                                    {{personInfoData.jtzz}}
                                </el-form-item>

                            </el-form>
                        </el-scrollbar>

                    </div>
                </div>
            </el-dialog>


            <el-dialog id="personInfoDialog" class="formDialog" title="信息补全" :visible.sync="supplementInfoDialogVisible"
                       width="90%" top="-20px">
                <div id="mobileMode_person" style="height: 200px;padding: 10px 20px">
                    <div id="listArea_person">
                        <el-scrollbar>
                            <el-form label-width="84px" label-position="left" width="100%">

                                <el-form-item label="联系电话">
                                    <el-input v-model="supplementInfoForm.lxdh" :maxlength="30" placeholder="请输入"/>
                                </el-form-item>

                            </el-form>
                        </el-scrollbar>
                    </div>
                    <div style="width:100%; text-align:center;">
                        <el-button type="primary" @click="saveSupplementInfo">保 存</el-button>
                        <el-button @click="supplementInfoDialogVisible = false" style="margin-left:10px;">取 消</el-button>
                    </div>
                </div>

            </el-dialog>


        </div>
    </div>
</template>

<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";
    import {
        globalConfig
    } from "static/config"

    export default {
        data() {
            return {
                supplementInfoDialogVisible:false,
                supplementInfoForm:{
                    lxdh:''
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                userCode: "",

                WKStuDialogVisible: false,
                WKStuTableLoading: false,
                WKStuTableData: [],
                WKStuMainTableHeight: 500,
                //个人报名信息
                WKStuForm: {
                    pageNum: 1,
                    rowNum: 20,
                    jfzt: null
                },

                //报名
                applyForm: {
                    wkksbh: null,
                    wkkslx: null
                },

                personInfoDialogVisible: false,

                //个人信息
                personInfoData: {
                    xm: "",
                    xh: "",
                    xb: "",
                    bj: "",
                    csny: "",
                    sfzh: "",
                    zzmm: "",
                    mz: "",
                    lxdh: "",
                    dzyx: "",
                    zplj: ""
                },
                imageUrl: '',
                fileImgList: []
            };
        },
        created() {
            this.queryUserInfo();
            this.personInfo();
        },
        mounted() {

        },
        methods: {
            saveSupplementInfo(){
                this.$api.outsideExam.studentSelection.saveSupplementInfo({
                    data: this.supplementInfoForm,
                })
                    .then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'success':
                                this.personInfoData.lxdh = this.supplementInfoForm.lxdh
                                this.supplementInfoDialogVisible = false;
                                showNotify('成功', '保存成功', 'success', 1500);
                                break;
                            default:
                                showNotify('错误', '保存失败', 'error', 3000);
                                break;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            openSupplementInfoDialog(){
                this.supplementInfoForm.lxdh = this.personInfoData.lxdh
            },
            //个人信息
            personInfo() {
                this.$api.outsideExam.studentSelection.stuInfo({})
                    .then((res) => {
                        if (res.data.data != null) {
                            this.personInfoData = res.data.data
                            this.imageUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res.data.data
                                .zplj;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //点击报名
            checkBM(row) {
                this.applyForm.wkksbh = row.wkksbh;
                this.applyForm.wkkslx = row.wkkslx;
                if (this.userCode != globalConfig.auth.xs) {
                    this.$message({
                        message: '只有学生可以报名',
                        type: 'warning'
                    });
                    return;
                } else {
                    if(this.personInfoData.lxdh===null || this.personInfoData.lxdh===''){
                        this.$message({
                            message: '请先补全个人信息',
                            type: 'warning'
                        });
                        return;
                    }

                    this.$api.outsideExam.studentSelection.jiaoFei({
                            data: this.applyForm,
                        })
                        .then((res) => {
                            let state = res.data.data;
                            switch (state) {
                                case 'pay':
                                    this.$alert('已缴费成功', '提示', {
                                        confirmButtonText: '确定',
                                        customClass: 'el-message-box-mobile',
                                    });
                                    break;
                                case 'notPay':
                                    confirmMsg('确定报名这门考试吗？', 'el-message-box-mobile').then(() => {
                                        this.$api.outsideExam.studentSelection.checkBM({
                                                data: this.applyForm,
                                            })
                                            .then((res) => {
                                                if (res.data.data == "no") {
                                                    this.apply()
                                                } else {
                                                    this.$alert('您已经报名过这门考试了', '提示', {
                                                        confirmButtonText: '确定',
                                                        customClass: 'el-message-box-mobile',
                                                    });
                                                }
                                            })
                                            .catch((err) => {
                                                console.log(err);
                                            });
                                    });
                                    break;
                                case 'cantApply':
                                    this.$alert('您的英语四级分数未超过425分，不能报名英语六级考试', '提示', {
                                        confirmButtonText: '确定',
                                        customClass: 'el-message-box-mobile',
                                    });
                                    break;
                                default:
                                    this.$notify({
                                        title: '错误',
                                        message: "错误",
                                        type: 'error',
                                        duration: 3000,
                                    });
                                    break;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            },
            //报名
            apply() {
                this.$api.outsideExam.studentSelection.apply({
                        data: this.applyForm,
                    })
                    .then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'Success':
                                this.WKStuDialogVisible = false;
                                this.$notify({
                                    title: '成功',
                                    message: '报名成功',
                                    type: 'success',
                                    duration: 1500,
                                });
                                this.requeryList();
                                break;
                            default:
                                this.$notify({
                                    title: '错误',
                                    message: "报名失败",
                                    type: 'error',
                                    duration: 3000,
                                });
                                break;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            WKStu() {
                this.WKStuDialogVisible = true;
            },
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    if (res.data.data) {
                        this.userCode = Object.keys(res.data.data.roles)
                        this.queryList();
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.outsideExam.studentSelection.queryList({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = this.tableData.concat(response.data.data.list);

                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            showHomePage() {
                this.$router.push('/m/wx/home');
            },
            handleScroll() {
                if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if (ele) {
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                } else {
                    return false;
                }
            },
            scrollToTop() {
                const ele = document.getElementById('listArea');
                if (ele) {
                    ele.scrollTop = 0;
                }
            },
            requeryList() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },


            queryWKStu() {
                this.WKStuTableLoading = true;
                this.$api.outsideExam.studentSelection.WKStuList({
                        data: this.WKStuForm,
                    })
                    .then((res) => {
                        this.WKStuTableData = res.data.data.list;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            //删除考试
            delWKSelection(row) {
                confirmMsg('是否确认删除该报名？', 'el-message-box-mobile').then(() => {
                    this.applyForm.wkksbh = row.wkksbh;
                    this.$api.outsideExam.studentSelection.delWKSelection({
                            data: row.id,
                        })
                        .then((res) => {
                            let state = res.data.data;
                            switch (state) {
                                case 'Success':
                                    this.WKStuDialogVisible = false;
                                    this.$notify({
                                        title: '成功',
                                        message: '删除成功',
                                        type: 'success',
                                        duration: 1500,
                                    });
                                    this.requeryList();
                                    break;
                                default:
                                    this.$notify({
                                        title: '错误',
                                        message: "删除失败",
                                        type: 'error',
                                        duration: 3000,
                                    });
                                    break;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
            },
            loadStateImg(row) {
                if (row.sfbm === '1') {
                    //已报名
                    return require('image/mobile/auditState/ybm.png');
                }
            },
        }
    };
</script>

<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode #queryArea {
        height: 40px;
        margin: 10px 0 10px 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 75vh;
        padding: 10px 20px;
    }

    #mobileMode #listArea {
        height: calc(100% - 140px);
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    #mobileMode #listArea .cardText label {
        width: 120px;
        display: inline-block;
    }

    /* 个人选课页面 */
    #mobileMode_person {
        height: 80vh;
        width: 100%;
        margin: 0;
        overflow: hidden;
    }

    #mobileMode_person #listArea_person {
        height: calc(100% - 80px);
        overflow-y: auto;
        margin-top: 12px;
    }

    #mobileMode_person #listArea_person .cardTips {
        width: 90%;
        height: 100%;
        font-size: 18px;
        font-weight: bold;
        color: #DCDFE6;
        border: 1px solid #DCDFE6;
        border-radius: 5px;
        margin-left: 5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #mobileMode_person #listArea_person .cardMain {
        margin: 0.5em 0 1em 0;
        width: 90%;
        height: auto;
        box-shadow: 0 0 10px #e7e7e7;
        border-radius: 10px;
        margin-left: 5%;
    }

    #mobileMode_person #listArea_person .cardText {
        padding: 0.2em 01em 0.2em 1em;
        position: relative;
    }

    #mobileMode_person #listArea_person .cardText label {
        width: 100px;
        display: inline-block;
    }

    #mobileMode_person #listArea_person .cardInput {
        border-top: 1px #e7e7e7 solid;
        padding: 0.5em;
        text-align: right;
    }

    #mobileMode_person #listArea_person .cardText .auditStateImg {
        width: 100px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 0;
    }

    #mobileMode_person #listArea_person .auditStateImg img {
        width: 100%;
        height: 100%;
    }

    #personInfoDialog {
        top: -30px;
    }

    /* 个人选课页面结束 */
</style>



// WEBPACK FOOTER //
// outsideStudentSelection.vue?63c8e79b